<template>
    <div class="min-h-screen grid lg:grid-cols-2">
        <!-- Left: form -->
        <div class="bg-white flex flex-col min-h-screen px-6 sm:px-10 lg:pl-[130px] lg:pr-10 pt-6">
            <div class="flex-1 flex flex-col justify-center w-full max-w-[510px] mx-auto lg:mx-0 py-6">
                <img src="../assets/logo.png" class="w-40 sm:w-44 mb-5" alt="SIRIMMATRIX" />
                <h1 class="text-[22px] sm:text-[24px] font-medium leading-[1.2] text-[#101414] mb-3">Bem-vindo de volta!</h1>
                <p class="text-[15px] sm:text-[16px] text-[#333A44] leading-[1.6] mb-5 max-w-[500px]">
                    Faça login para acessar sua conta.
                </p>

                <form @submit.prevent>
                    <!-- Email -->
                    <div class="mb-7">
                        <label class="block text-[16px] font-medium text-[#171717] mb-2.5">E-mail</label>
                        <div class="relative">
                            <span class="absolute left-4 top-1/2 -translate-y-1/2 text-cyan-600">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                </svg>
                            </span>
                            <input
                                type="email"
                                inputmode="email"
                                v-model="username"
                                maxlength="60"
                                placeholder="seuemail@email.com"
                                @keyup.enter="login()"
                                class="w-full h-[58px] pl-12 pr-4 text-base bg-white border border-[#D9D9D9] rounded-xl text-[#171717] placeholder:text-gray-400 focus:outline-none focus:border-cyan-600 focus:ring-2 focus:ring-cyan-600/15 transition-colors"
                            />
                        </div>
                    </div>

                    <!-- Password -->
                    <div>
                        <label class="block text-[16px] font-medium text-[#171717] mb-2.5">Senha</label>
                        <div class="relative">
                            <span class="absolute left-4 top-1/2 -translate-y-1/2 text-cyan-600">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 0h10.5a2.25 2.25 0 012.25 2.25v6.75a2.25 2.25 0 01-2.25 2.25H6.75a2.25 2.25 0 01-2.25-2.25v-6.75a2.25 2.25 0 012.25-2.25z" />
                                </svg>
                            </span>
                            <input
                                :type="showPassword ? 'text' : 'password'"
                                v-model="password"
                                maxlength="60"
                                placeholder="Digite sua senha"
                                @keyup.enter="login()"
                                class="w-full h-[58px] pl-12 pr-12 text-base bg-white border border-[#D9D9D9] rounded-xl text-[#171717] placeholder:text-gray-400 focus:outline-none focus:border-cyan-600 focus:ring-2 focus:ring-cyan-600/15 transition-colors"
                            />
                            <button
                                type="button"
                                @click="showPassword = !showPassword"
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-cyan-600 transition-colors"
                                tabindex="-1"
                            >
                                <svg v-if="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.93 3.93m0 0a3 3 0 104.243 4.243m-4.243-4.243L17.577 17.577m-4.243-4.243l4.243 4.243" />
                                </svg>
                                <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Forgot password -->
                    <div class="flex justify-end mt-3 mb-6">
                        <router-link :to="{ name: 'forgotPassword' }" class="text-[14px] font-medium text-cyan-600 hover:underline">Esqueci minha senha?</router-link>
                    </div>

                    <!-- Primary button -->
                    <button
                        type="button"
                        @click="login()"
                        :disabled="loading"
                        class="w-full h-[58px] rounded-xl bg-cyan-600 text-white font-medium text-base hover:bg-cyan-700 disabled:opacity-60 transition-colors flex items-center justify-center gap-2"
                    >
                        <svg v-if="loading" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {{ loading ? 'Verificando...' : 'Entrar' }}
                    </button>

                    <!-- OR separator -->
                    <div class="relative flex items-center my-7">
                        <div class="flex-grow border-t border-[#E0E0E0]"></div>
                        <span class="mx-4 text-[13px] text-[#333A44] font-medium">ou</span>
                        <div class="flex-grow border-t border-[#E0E0E0]"></div>
                    </div>

                    <!-- Google -->
                    <button
                        type="button"
                        @click="loginWithGoogle"
                        :disabled="loadingGoogle"
                        class="w-full h-[58px] rounded-xl bg-white border border-[#DCDCDC] text-[#171717] font-medium text-base hover:bg-gray-50 disabled:opacity-60 transition-colors flex items-center justify-center gap-3.5"
                    >
                        <svg v-if="loadingGoogle" class="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <svg v-else viewBox="0 0 24 24" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                        </svg>
                        {{ loadingGoogle ? 'Aguarde...' : 'Continuar com Google' }}
                    </button>

                    <div class="flex flex-col items-center gap-2 mt-2">
                        <BaseErrorMessage :message="authError" />
                        <button
                            v-if="needsConfirmation"
                            type="button"
                            @click="resendConfirmation"
                            :disabled="resendingConfirmation"
                            class="text-[14px] font-medium text-cyan-600 hover:underline disabled:opacity-60"
                        >
                            {{ resendingConfirmation ? 'Reenviando...' : 'Reenviar email de confirmação' }}
                        </button>
                        <p v-if="resendMessage" class="text-emerald-600 text-sm">{{ resendMessage }}</p>
                    </div>

                    <p class="text-center text-[15px] text-[#333A44] mt-7">
                        Não tem uma conta?
                        <router-link :to="{ name: 'createAccount' }" class="font-medium text-cyan-600 hover:underline ml-1">Cadastre-se</router-link>
                    </p>
                </form>
            </div>
        </div>

        <!-- Right: branding -->
        <AuthBrandingPanel />
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import AuthService from '../services/AuthService';
import GoogleAuthService from '../services/GoogleAuthService';
import AuthBrandingPanel from '../components/AuthBrandingPanel.vue';
import { useRouter } from 'vue-router';

export default {
    name: 'Login',
    components: { AuthBrandingPanel },
    setup() {
        let loading = ref(false);
        let loadingGoogle = ref(false);
        let authError = ref(null);
        const username = ref();
        const password = ref();
        const showPassword = ref(false);
        const needsConfirmation = ref(false);
        const resendingConfirmation = ref(false);
        const resendMessage = ref('');
        const router = useRouter();
        const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID || null;

        onMounted(() => {
            const loggedUser = AuthService.getAuthInfo();
            if (loggedUser && loggedUser.token && loggedUser.id) {
                router.push({ name: 'home' });
            }
        });

        async function login() {
            try {
                loading.value = true;
                authError.value = null;
                needsConfirmation.value = false;
                resendMessage.value = '';
                username.value = typeof username.value === 'string' ? username.value.trim() : username.value;
                password.value = typeof password.value === 'string' ? password.value.trim() : password.value;

                const { data: { data } } = await AuthService.authenticate(username.value, password.value);
                AuthService.storeLocalData({ ...data });
                router.push({ name: 'home' });
            } catch (err) {
                const errCode = err?.response?.data?.error;
                if (errCode === 'email_not_confirmed') {
                    authError.value = 'Confirme seu email para acessar. Verifique sua caixa de entrada.';
                    needsConfirmation.value = true;
                } else if (errCode === 'company_inactive') {
                    authError.value = err.response.data.text || 'Empresa desativada. Entre em contato com o suporte.';
                } else {
                    authError.value = 'Email ou senha inválido(a)';
                }
                loading.value = false;
            }
        }

        async function resendConfirmation() {
            resendingConfirmation.value = true;
            resendMessage.value = '';
            try {
                await AuthService.resendConfirmation(username.value);
                resendMessage.value = 'Email reenviado. Confira sua caixa de entrada.';
            } catch {
                resendMessage.value = 'Erro ao reenviar. Tente novamente em instantes.';
            } finally {
                resendingConfirmation.value = false;
            }
        }

        async function loginWithGoogle() {
            if (!googleClientId) {
                authError.value = 'Login com Google não configurado.';
                return;
            }
            loadingGoogle.value = true;
            authError.value = null;
            try {
                const idToken = await GoogleAuthService.getGoogleIdToken(googleClientId);
                if (!idToken) {
                    authError.value = 'Login com Google cancelado.';
                    return;
                }
                const { data: { data } } = await AuthService.loginWithGoogle(idToken);
                AuthService.storeLocalData({ ...data });
                router.push({ name: 'home' });
            } catch (err) {
                const errCode = err?.response?.data?.error;
                if (errCode === 'account_not_found') {
                    authError.value = 'Conta não encontrada. Crie uma conta primeiro.';
                } else {
                    authError.value = 'Erro ao autenticar com Google. Tente novamente.';
                }
            } finally {
                loadingGoogle.value = false;
            }
        }

        return { loading, loadingGoogle, login, loginWithGoogle, authError, username, password, showPassword, googleClientId, needsConfirmation, resendingConfirmation, resendMessage, resendConfirmation };
    }
}
</script>
